import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {MessageService} from '@mctic/ng-core';
import {ToastrService} from 'ngx-toastr';
import { Observable } from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import { SecurityService } from '../service';
import {PerfilCorporativoService} from '../service/perfil-corporativo.service';
import {PerfilCorporativoVO} from '../shared';
import {PerfilEnum} from '../shared/enum/perfil.enum';

@Injectable({
  providedIn: 'root'
})
export class PermissaoAcessoPleitoGuard implements CanActivate {

  constructor(private readonly securityService: SecurityService,
              private readonly router: Router,
              private readonly perfilCorporativoService: PerfilCorporativoService,
              private readonly toastr: ToastrService,
              private readonly messageService: MessageService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable(subscriber => {
      this.securityService.obterUsuarioAutenticado().pipe(
        filter((usuario) => usuario != undefined),
        switchMap((usuario) =>
          this.perfilCorporativoService.consultarPerfisPorUsuario(usuario.login)
        )).subscribe((perfis: PerfilCorporativoVO[]) => {
        if (this.verificarPerfisRepresentante(perfis)) {
          subscriber.next(true);
          subscriber.complete();
        } else {
          this.router.navigate(['/home']).then(() => {
            this.toastr.error(this.messageService.findById('usuarioSemPerfilAcessoPleito').description);
            subscriber.next(false);
            subscriber.complete();
          });
        }
      });
    });
  }
  private verificarPerfisRepresentante(perfis: PerfilCorporativoVO[]): boolean {
    return perfis.includes(perfis.find(perfil =>
      perfil.nome === PerfilEnum.ResponsavelTecnicoPleito ||
      perfil.nome === PerfilEnum.RepresentanteLegal ||
      perfil.nome === PerfilEnum.ResponsavelLegal ||
      perfil.nome === PerfilEnum.ResponsavelInstituicao
    ));
  }
}
